import React, { useState } from "react";
import WelcomeBanner from "../common/WelcomeBanner";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Button, TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../../services/authService";
import "./styles.scss";
import PasswordField from "../common/PasswordField/PasswordField";
import { isEmail } from "../../utils/validators";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [apiError, setApiError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  let navigate = useNavigate();

  const emailChangeHandler = (event: any) => {
    event.preventDefault();
    setError(false);
    setEmail(event.target.value);
    if (email) {
      setApiError("");
    }
  };

  const passwordChangeHandler = (event: any) => {
    event.preventDefault();
    setPassword(event.target.value);
    if (password) {
      setApiError("");
    }
  };

  const handleSubmit = () => {
    setIsLoading(true);
    loginUser(email, password)
      .then((response: { data: { token: any } }) => {
        const token = response?.data?.token;
        localStorage.setItem("user", token);
        if (token) {
          return navigate("/");
        }
        setIsLoading(false);
      })
      .catch((err: { response: { status: number } }) => {
        setIsLoading(false);
        if (!err?.response) {
          setApiError("No Server Response");
        } else if (err.response?.status === 400) {
          setApiError("Missing Username or Password");
        } else if (err.response?.status === 401) {
          setApiError(
            "Either your email or password is incorrect, please try again"
          );
        } else {
          setApiError("Login Failed");
        }
      });
  };

  const handleLoginBtnClick = () => {
    const isValidEmail = isEmail(email);
    setError(!isValidEmail);
    if (isValidEmail) {
      setIsLoading(true);
      handleSubmit();
    }
  };

  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };

  return (
    <Box component="div" className="login-container">
      <Box sx={{ my: 1 }}>
        <WelcomeBanner />
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <Card className="card-container">
          <CardContent className="card-content">
            <Typography className="login-text">Log in to TI Quest</Typography>
            <form autoComplete="off" onSubmit={handleSubmit} className="form">
              <TextField
                id="outlined-error-helper-text"
                type="email"
                inputProps={{ "data-testid": "emailId" }}
                onChange={emailChangeHandler}
                value={email}
                error={error}
                helperText={error ? "Please enter valid email address" : ""}
                autoComplete="off"
                label="Email"
                variant="outlined"
                fullWidth
                className="user-id-input"
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <PasswordField
                label="Password"
                changeHandler={passwordChangeHandler}
                testId="password"
                value={password}
                
              />
              <Typography variant="sFormHelper" className="error-message">
                {apiError}
              </Typography>
              <LoadingButton
                fullWidth
                variant="contained"
                data-testid="loginBtn"
                size="small"
                className="login-button"
                disabled={!email || !password}
                onClick={handleLoginBtnClick}
                loading={isLoading}
              >
                Log In
              </LoadingButton>
            </form>
            <Button
              fullWidth
              className="forgot-password-button"
              onClick={handleForgotPassword}
            >
              Forgot password ?
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default Login;
